module.exports = " <div class=\"chart-container\"> <canvas id=\"{{vm.chartid}}\"></canvas> </div> <div class=\"legend-con\" id=\"{{vm.chartid}}-legend\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-pie-charts/dv-pie-charts.html
// module id = Etn9
// module chunks = 0